
import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Prayer } from '@/types/prayer';

interface CommentButtonProps {
  onComment: (prayer?: Prayer) => void;
  commentCount: number;
  prayer?: Prayer;
  baseButton?: string;
  accentGlow?: string;
  size?: 'sm' | 'md' | 'lg';
  showCount?: boolean;
}

export default function CommentButton({
  onComment,
  commentCount,
  prayer,
  baseButton = 'relative flex items-center justify-center p-3 rounded-full transition-all duration-300 border-2 border-transparent',
  accentGlow = 'hover:border-blue-500/50 hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]',
  size = 'md',
  showCount = true
}: CommentButtonProps) {
  const iconSize = size === 'sm' ? 16 : size === 'lg' ? 24 : 20;
  const buttonSizeClasses = size === 'sm' ? 'w-8 h-8 p-2' : size === 'lg' ? 'w-12 h-12 p-3' : 'w-10 h-10 p-2.5';

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onComment(prayer);
      }}
      className={`${baseButton} ${buttonSizeClasses} group ${accentGlow} shadow-[0_8px_36px_0_rgba(33,150,243,0.10)] hover:bg-blue-400/10 hover:text-blue-700 dark:hover:text-blue-300 active:scale-95`}
      tabIndex={0}
      aria-label={`View comments (${commentCount})`}
      style={{ touchAction: 'manipulation' }}
    >
      <MessageCircle size={iconSize} />
      {showCount && commentCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs rounded-full min-w-5 h-5 flex items-center justify-center px-1 font-medium">
          {commentCount > 99 ? '99+' : commentCount}
        </span>
      )}
    </button>
  );
}
